import { get } from '@eika-infrastruktur/request';
import { RequestException } from '@eika-infrastruktur/request/src/exceptions';

import type { Context, InvoiceDocument } from '../generated-types';
import { CONTEXT_PATH } from './index';

export const SERVICE_PATH = 'rest/resource/keepalive';

const keepAlive = async (context: Context): Promise<boolean> => {
    try {
        await get<InvoiceDocument[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/?context=${context}`);
        return true;
    } catch (exception: unknown) {
        if (exception instanceof RequestException) {
            if (exception.status === 403 || exception.status === 401) {
                return false;
            }
        }
        return true;
    }
};

export default keepAlive;
